import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { Button } from '@/components/UI/Button/Button';

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 166px;
  align-items: center;
  text-align: center;
  justify-content: center;
  border: 0.5px solid ${({ theme }) => theme.palette.primary.border};
  border-radius: 14px;
  padding: 40px 5px;
  user-select: none;
  aspect-ratio: 255 / 280;

  @media (max-width: ${({ theme }) => theme.breakpoints.xsm}) {
    min-width: 130px;
  }
`;

export const Title = styled(Typography.Header)`
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 14px;
  }

  margin-bottom: 10px;
`;

export const Description = styled(Typography.Caption).attrs({
  $variant: '1',
})`
  font-size: 16px;
  margin-bottom: 25px;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 10px;
  }
`;

export const AddButton = styled(Button).attrs({
  borderRadius: 20,
  appearance: 'primary',
})`
  height: 36px;
  padding: 0 15px;
  font-size: 13px;
`;
